import { handleApiResult } from '@store/error';
import { apiSlice } from './apiSlice';

export interface SeatSession {
  licenseId: string;
  sessionId: string;
  id: string;
  packageIdentifier: string;
  app: 'supar' | 'composer' | null;
  deviceId: string;
  deviceName?: string;
  deviceModel?: string;
  operatingSystem?: string;
  runtimePlatform?: string;
  version?: string;
  lastUpdate: string;
  allocationTimeRequest?: string;
  /** Seconds before this seat could be handed to another client. */
  reclaimableInSeconds: number;
  /** No heartbeat within the reconnection window. */
  stale: boolean;
}

export const seatSessionApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getSeatSessions: builder.query<SeatSession[], void>({
      query: () => '/v1/seat-sessions',
      providesTags: ['SeatSession'],
      onQueryStarted: handleApiResult(),
    }),
    revokeSeatSession: builder.mutation<void, { licenseId: string, sessionId: string }>({
      query: ({ licenseId, sessionId }) => ({
        url: `/v1/licenses/${licenseId}/seat-sessions/${sessionId}`, method: 'DELETE'
      }),
      // The seat frees up immediately, so the license usage counters move too.
      invalidatesTags: ['SeatSession', 'License'],
      onQueryStarted: handleApiResult('Seat released.'),
    }),
  }),
});

export const {
  useGetSeatSessionsQuery,
  useRevokeSeatSessionMutation,
} = seatSessionApiSlice;
